export default __webpack_public_path__ + "static/media/warning.23a78f5c.svg";